import * as tslib_1 from "tslib";
import { ActionTypeEnum } from '@core/components/fc-tree-view/fc-tree.types';
import { TranslateService } from '@ngx-translate/core';
import { flatMapDeep } from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
var DialogLinkService = /** @class */ (function () {
    function DialogLinkService(translateService) {
        this.translateService = translateService;
        this.linkedEquipments = [];
        this.linkedSectors = [];
        this.linkedEnvironments = [];
    }
    DialogLinkService.prototype.getLinkedItems = function (params) {
        var locationLinks = params.locationLinks, unlinkedEquipments = params.unlinkedEquipments;
        var sectors = this.mapCheckedItems(locationLinks, 'sector');
        var flattedMaintenanceLinks = flatMapDeep(locationLinks, function (item) { return item.children; });
        var environments = this.mapCheckedItems(flattedMaintenanceLinks, 'environment');
        var equipments = this.mapCheckedItems(flattedMaintenanceLinks, 'equipment');
        var flattedEquipmentsFromEnvironmentsToSave = flatMapDeep(environments, function (environment) { return environment.children; });
        var equipmentsInsideEnvironments = this.mapCheckedItems(flattedEquipmentsFromEnvironmentsToSave, 'equipment');
        equipmentsInsideEnvironments.forEach(function (equipment) {
            equipments.push(equipment);
        });
        if (unlinkedEquipments.length) {
            var unlinkedEquipmentsToSave = this.mapCheckedItems(unlinkedEquipments[0].children, 'equipment');
            unlinkedEquipmentsToSave.forEach(function (equipment) {
                equipments.push(equipment);
            });
        }
        var sectorsToSave = sectors.map(function (sector) { return sector.original; }).filter(function (sector) { return !sector.archived; });
        this.linkedSectors.forEach(function (linkedSector) {
            var existingSector = sectorsToSave.find(function (item) { return item.id === linkedSector.id; });
            if (!existingSector) {
                sectorsToSave.push(linkedSector);
            }
        });
        var environmentsToSave = environments.map(function (environment) { return environment.original; });
        this.linkedEnvironments.forEach(function (linkedEnvironment) {
            var existingEnvironment = environmentsToSave.find(function (item) { return item.id === linkedEnvironment.id; });
            if (!existingEnvironment) {
                environmentsToSave.push(linkedEnvironment);
            }
        });
        var equipmentsToSave = equipments.map(function (equipment) { return equipment.original; });
        this.linkedEquipments.forEach(function (linkedEquipment) {
            var existingEquipment = equipmentsToSave.find(function (item) { return item.id === linkedEquipment.id; });
            if (!existingEquipment) {
                equipmentsToSave.push(linkedEquipment);
            }
        });
        environmentsToSave.forEach(function (env, index) {
            var hasSector = sectorsToSave.some(function (sector) { return sector.id === env.locationSector.id; });
            if (!hasSector) {
                environmentsToSave.splice(index, 1);
            }
            if (env.archived) {
                environmentsToSave.splice(index, 1);
            }
        });
        equipmentsToSave.forEach(function (eq, index) {
            if (eq.locationSector) {
                var hasSector = sectorsToSave.some(function (sector) { return sector.id === eq.locationSector.id; });
                if (!hasSector) {
                    equipmentsToSave.splice(index, 1);
                }
            }
            if (eq.locationEnvironment) {
                var hasEnvironment = environmentsToSave.some(function (environment) { return environment.id === eq.locationEnvironment.id; });
                if (!hasEnvironment) {
                    equipmentsToSave.splice(index, 1);
                }
            }
            if (eq.archived) {
                equipmentsToSave.splice(index, 1);
            }
        });
        return {
            sectors: sectorsToSave,
            equipments: equipmentsToSave,
            environments: environmentsToSave,
        };
    };
    DialogLinkService.prototype.formatSectors = function (params) {
        var _this = this;
        var sectors = params.sectors;
        return (sectors || []).map(function (sector) {
            var sectorItem = {
                id: sector.id,
                text: sector.name,
                description: sector.description,
                icon: 'sector',
                metadata: 'sector',
                original: sector,
                action: {
                    type: ActionTypeEnum.checkbox,
                    checked: Boolean((_this.linkedSectors || []).some(function (locationSector) { return locationSector.id === sector.id; })),
                }
            };
            sectorItem.children = tslib_1.__spread(_this.formatEnvironments({
                environments: sector.locationEnvironments,
                parent: sectorItem,
            }), _this.formatEquipments({
                equipments: sector.equipments,
                parent: sectorItem,
            }));
            return sectorItem;
        });
    };
    DialogLinkService.prototype.formatUnlinkedEquipments = function (params) {
        var unlinkedEquipments = params.unlinkedEquipments;
        var formattedEquipments = this.formatEquipments({ equipments: unlinkedEquipments });
        if (!formattedEquipments.length) {
            return [];
        }
        return [{
                text: this.translateService.instant('MAINTENANCES.CREATE_DIALOG.TAB_LINKS.EQUIPMENTS_WITHOUT_SECTOR_ENVIRONMENT'),
                icon: 'more_vertical',
                children: formattedEquipments,
                action: {
                    type: ActionTypeEnum.none
                }
            }];
    };
    DialogLinkService.prototype.formatEnvironments = function (params) {
        var _this = this;
        var parent = params.parent, environments = params.environments;
        return (environments || []).map(function (environment) {
            var environmentItem = {
                id: environment.id,
                text: environment.name,
                description: environment.description,
                icon: 'environment',
                original: environment,
                parent: parent,
                metadata: 'environment',
                action: {
                    type: ActionTypeEnum.checkbox,
                    checked: Boolean((_this.linkedEnvironments || []).some(function (locationEnvironment) { return locationEnvironment.id === environment.id; }))
                }
            };
            environmentItem.children = _this.formatEquipments({
                parent: environmentItem,
                equipments: environment.equipments,
            });
            return environmentItem;
        });
    };
    DialogLinkService.prototype.formatEquipments = function (params) {
        var _this = this;
        var equipments = params.equipments, parent = params.parent;
        return (equipments || []).map(function (equipment) { return ({
            id: equipment.id,
            text: equipment.name,
            description: equipment.number,
            icon: 'equipment',
            image: equipment.imageUrl,
            children: [],
            parent: parent,
            original: equipment,
            metadata: 'equipment',
            action: {
                type: ActionTypeEnum.checkbox,
                checked: Boolean((_this.linkedEquipments || []).some(function (linkedEquipment) { return linkedEquipment.id === equipment.id; }))
            }
        }); });
    };
    DialogLinkService.prototype.mapCheckedItems = function (treeViewItems, metadata) {
        return treeViewItems.filter(function (item) { return item.metadata === metadata && item.action.checked; });
    };
    DialogLinkService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DialogLinkService_Factory() { return new DialogLinkService(i0.ɵɵinject(i1.TranslateService)); }, token: DialogLinkService, providedIn: "root" });
    return DialogLinkService;
}());
export { DialogLinkService };
